






















































import { Component, Vue } from 'vue-property-decorator';
import ExportUiStateModule from '@/store/modules/ExportUiStateModule';
import { IIntegrationResults } from '@/store/types/IIntegrationResults';

// todo rename this class to ExportCompleteIntegrationPublishFailures
// downloads can't have failures
@Component
export default class ExportCompleteFailures extends Vue {
  get exportResult() {
    return ExportUiStateModule.completeExportById(
      Number(this.$route.params.exporthistoryid),
    );
  }

  get integrationResults(): IIntegrationResults {
    return this.exportResult!.publishResult.integrationResults;
  }
}
